export default {
  title: 'Google-reviewprogramma',
  sections: {
    google_review_settings: 'Instellingen Google-reviewprogramma',
  },
  form: {
    reward: {
      label: 'Beloning (punten)',
      point_value: '100 punten = {{moneyValue}}',
    },
    has_end_date: {
      label: 'Duur',
      options: {
        false: 'Onbeperkt',
        true: 'Met specifieke einddatum',
      },
    },
    end_date: {
      label: 'Einddatum',
    },
  },
  tags: {
    inactive: 'Niet actief',
    active: 'Actief',
    expired: 'Verlopen',
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    failed_to_load_data: 'Laden van gegevens mislukt',
    changes_got_saved: 'Wijzigingen zijn opgeslagen',
    failed_to_save_changes: 'Opslaan van wijzigingen mislukt',
  },
};
